

































import {
  ValidaProduto
} from "@/services/importacao.service";
import { ProdutosService } from "@/services/produtos.service";
import DatePicker from "@/shared/components/date-picker.vue";
import InputMoeda from "@/shared/components/input-moeda.vue";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { Loading, Modal, InputMoeda, DatePicker },
})

export default class AlterarPrecoProduto extends Vue {
  validaProduto: ValidaProduto | null = null;
  value = {
    valor: 0,
    validoApos: '',
    idCatalogo: '',
    codigoFornecedor: ''
  }

  loading = false;

  get tituloAlterarPrecoProduto(){
    return this.validaProduto && this.validaProduto.produto.nome || "Alterar Preço"
  }

  rules = {
    preco: [required()],
    validoAte: [required()],
  };

  abrir(validaProduto: ValidaProduto) {
    this.loading = false;
    this.validaProduto = validaProduto
    this.value.valor = validaProduto.produto.valorUnitario;
    this.value.validoApos = moment().startOf('month').format('YYYY-MM-DD');
    
    if(this.$route.params.idCatalogo == null){
      this.value.idCatalogo = "1919c799-b173-11e8-a2a7-02f0d91faea6"
    }
    else{
      this.value.idCatalogo = this.$route.params.idCatalogo;
    }
    
    this.value.codigoFornecedor = validaProduto.produto.codigo;

    const modal = this.$refs.modal as Modal;

    return modal.open();
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  salvarPreco(){
    this.loading = true;

    ProdutosService.AlterarProdutoComHistoricoNaImportacao(this.value)

    this.validaProduto!.invalido = false;
    this.validaProduto!.produto.valorUnitario = this.value.valor;
    this.validaProduto!.validoAte = this.value.validoApos;
    this.fechar();
  }
}
